import selectn from 'selectn'
import { common } from './common'
import moment from 'moment-timezone'
import dateFormat from '../../utils/dateformat'
import { relativeDate, isGeoRestricted, showCopyrightVideo } from '../../utils/common'
import classNames from 'classnames'
import translate from '../../utils/translate'
// TODO: Refactor after third column scoreboard APIs are ready
export const flex = {
  getColumnByName : function (columns, columnName) {
    try {
      for (var i = 0, len = columns.length; i < len; i++) {
        var column = columns[i]
        if(column.name === columnName) {
          return column
        }
      }
      return {}
    } catch (e) {
      return {}
    }
  },
  getModuleByType : function (items, moduleType) {
    try {
      for (var i = 0, len = items.length; i < len; i++) {
        var item = items[i]
        if(item.moduleType === moduleType) {
          return item
        }
      }
      return {}
    } catch (e) {
      return {}
    }
  },
  buildNewsItems : function (feed = [], limit = 6, domain) {
    var newsModule = []
    let ignoreTypes = [ 'VideoCollection' ]
    let ignoreDisplayTypes = [ 'Multi-card Collection', 'Headline Collection' ]
    let ignoreModuleType = [ 'collection' ]
    let availableRelatedTypes = [ 'StoryTrio', 'StoryDuo' ]

    try {
      for (var i = 0, len = feed.length; i < len; i++) {
        var feedItem = feed[i]
        var webLinks = selectn('links.web', feedItem) || {}

        // ignore videoCollection type in the news feed
        if((ignoreTypes.indexOf(feedItem.type) === -1) && (ignoreDisplayTypes.indexOf(feedItem.feedDisplayType) === -1) && (ignoreModuleType.indexOf(feedItem.moduleType) === -1)) {

          // if feed type is StoryTrio or StoryDuo, then consider the related items as news headlines
          if (availableRelatedTypes.indexOf(feedItem.type) > -1) {
            var related = feedItem.related
            if (related.length > 0) {
              for (var j = 0; j < related.length; j++) {
                var relatedItem = related[j]
                var relatedWebLinks = selectn('links.web', relatedItem) || {}
                newsModule.push({
                  headline: relatedItem.headline,
                  type: relatedItem.type,
                  description: relatedItem.description,
                  href: common.buildURL(relatedWebLinks.href || selectn('headline.href', relatedWebLinks), domain) || '#',
                  image: selectn('images[0]', relatedItem) || {}
                })
              }
            }
          } else {
            newsModule.push({
              headline: feedItem.headline,
              type: feedItem.type,
              description: feedItem.description,
              href: common.buildURL(webLinks.href || selectn('headline.href', webLinks), domain) || '#',
              image: selectn('images[0]', feedItem) || {}
            })
          }
        }
      }

      newsModule = newsModule.slice(0, limit)

      return newsModule
    } catch (e) {
      console.log(e)
    }
    return newsModule
  },
  buildEditorialItems : function (feed = [], edition = {}) {
    var editorialContent = []
    const domain = edition && edition.domain || ''
    const userGeo = edition && edition.userGeo || ''
    const site = edition && edition.site || ''
    let isNonSonyRightContent = true

    try {
      for (var i = 0, len = feed.length; i < len; i++) {
        var feedItem = feed[i]
        var webLinks = selectn('links.web', feedItem) || {},
          images = selectn('images[0]',feedItem),
          image = images && {
            url: images.url || '#',
            name: images.name || '',
            caption: images.caption || ''
          },
          videos = selectn('video[0]',feedItem),
          vidLinks = videos && videos.links.web || '#',
          video = videos && {
            id: videos.id,
            cerebroId: videos.cerebroId || '',
            headline: videos.headline,
            caption: videos.caption || '',
            href: common.buildURL(webLinks.href || vidLinks.href , domain) || '#',
            trackingName: videos.tracking.trackingName,
            thumbnail: videos.thumbnail || '',
            title: videos.title || '',
            duration: videos.duration || '',
            deviceRestrictions: videos.deviceRestrictions || {},
            geoRestrictions: videos.geoRestrictions || {}
          }
        let isVideoGeoRestricted =  videos && isGeoRestricted(videos.geoRestrictions, userGeo.toUpperCase()) || false
        if( videos ) {
          let copyRightsOptions = {
            site: site,
            domain: domain,
            userGeo: userGeo,
            isWebView: false
          }
          isNonSonyRightContent =  showCopyrightVideo(videos.ad, copyRightsOptions)
        } else {
          isNonSonyRightContent = true
        }


        let href = common.buildURL(webLinks.href || selectn('headline.href', webLinks), domain) || '#'
        let isLinkExternal = common.isLinkExternal(href, domain)

        if(isNonSonyRightContent && !isVideoGeoRestricted && feedItem.headline && (images || videos)) {
          editorialContent.push({
            headline: feedItem.headline,
            type: feedItem.type,
            description: feedItem.description,
            href: href,
            isLinkExternal: isLinkExternal,
            target: isLinkExternal ? '_blank' : '',
            externalLinkClass: isLinkExternal ? 'external' : '',
            image: image,
            video: video
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
    return editorialContent
  },
  /**
   * [getSchedulesItems gets all fixtures, results as an object]
   * @param  {[type]} data [raw api data]
   * @param  {[type]} sport [sport type]
   * @param  {[type]} edition [edition type]
   * @param  {[type]} pageType [page type]
   * @param  {[type]} limit [number of rows]
   * @param  {[type]} team [clubhouse team info]
   * @return {[type]}      [array]
   */
  getSchedulesItems: function (data, sport, edition, pageType, limit, team) {

    let fixtures = [], results = [], live = []
    let schedule = { fixtures, results, live }

    const tzOptions = {
      // Set time zone to IST
      // TODO: use time zones based on editions
      timeZone : edition.timeZoneBucket,
      timeFormat : 'hh:mm a'
    }
    tzOptions.timeZoneAbbr = moment().tz(tzOptions.timeZone).format('z') || ''
    let transObj = {
      key : 'All times in',
      timezone : tzOptions.timeZoneAbbr || ''
    }
    let heading = {
      text: translate(edition, 'Matches'),
      timeZone: tzOptions.timeZoneAbbr ? translate(edition, transObj) : ''
    }
    let notes = team.recordSummary ? team.recordSummary : ''
    if(typeof team.standingSummary !== 'undefined') {
      notes += (team.standingSummary) ? `, ${team.standingSummary}` : ''
    }

    const dataLen = (typeof data.length !== 'undefined')  ? data.length : 0
    for(let i = 0; i < dataLen; i++) {

      let game = data[i] || {}
      //console.info('======>game',game)
      //add local date and time


      let trackingName = common.createTrackingName([ sport, 'TeamClubhouse', 'Schedule', game.status ])
      let gameObj = {
        date: game.date,
        status : game.status || '',
        id : game.id || '',
        shortDetail : game.shortDetail || '',
        leagueName : game.leagueName || '',
        leagueAbbreviation : game.leagueAbbreviation || '',
        score : game.score || '',
        homeAway : game.homeAway || '',
        href: common.buildURL(game.link) || '',
        trackingName: trackingName,
        isHTScoreAvailable: false
      }
      gameObj = flex.updateGameDateFormat(gameObj, tzOptions)

      //add default logo
      const opponentLogo = game.opponentLogo ? game.opponentLogo : common.defaultUrls['teamLogo']
      game.opponentLogo = common.resizeCombinerLogo(opponentLogo,{ w:25, h:25 })

      const teamLogo = team.logo ? team.logo : common.defaultUrls['teamLogo']
      team.logo = common.resizeCombinerLogo(teamLogo,{ w:25, h:25 })

      let teamA = {
        score : game.homeTeamScore || '',
        htscore : game.homeTeamHTScore || '',
        teamId : game.homeTeamId || '',
        className : 'team-a'
      }
      let teamB = {
        score : game.awayTeamScore || '',
        htscore : game.awayTeamHTScore || '',
        teamId : game.awayTeamId || '',
        className : 'team-b'
      }
      if(team.id === game.homeTeamId) {
        Object.assign(teamA, {
          logo : teamLogo,
          name : team.name || '',
          abbreviation : team.abbreviation || '',
          record : team.recordSummary ? `Form: ${team.recordSummary}` : ''
        })
        Object.assign(teamB,{
          logo : game.opponentLogo,
          name : game.opponentName,
          abbreviation : game.opponentAbbreviation,
          record : game.record ? `Form: ${game.record}` : ''
        })
      }else{
        Object.assign(teamB, {
          logo : teamLogo,
          name : team.name || '',
          abbreviation : team.abbreviation || '',
          record : team.recordSummary ? `Form: ${team.recordSummary}` : ''
        })
        Object.assign(teamA, {
          logo : game.opponentLogo,
          name : game.opponentName || '',
          abbreviation : game.opponentAbbreviation,
          record : game.record ? `Form: ${game.record}` : ''
        })
      }

      teamA.isWinner = (teamA.teamId === game.winnerTeamId) ? true : false
      teamB.isWinner = (teamA.isWinner === true) ? false : true

      gameObj.teamA = teamA
      gameObj.teamB = teamB

      //calculate HT scores like HT 12-15
      if(gameObj.teamA.hasOwnProperty('htscore') && (gameObj.teamB.hasOwnProperty('htscore'))) {
        gameObj.isHTScoreAvailable = true
        if((gameObj.status === 'in') || (gameObj.status === 'post')) {
          if((gameObj.teamA.htscore) && (gameObj.teamB.htscore)) {
            gameObj.htGameDetail = (`HT ${gameObj.teamA.htscore} - ${gameObj.teamB.htscore}`) || ''
          }
        }
      }
      //hide HT score for 1st half CIREARCH-1281, 1271
      if(gameObj.status === 'in') {
        gameObj.htGameDetail = ''
      }

      if((gameObj.teamA.teamId === game.winnerTeamId)) {
        gameObj.teamWinnerClassName = gameObj.teamA.className + '-winner'
      }else{
        gameObj.teamWinnerClassName = gameObj.teamB.className + '-winner'
      }

      let gameTimeMap = {
        'pre' : (gameObj.displayTimeFormatted ? gameObj.displayTimeFormatted : ''),
        'in' : 'LIVE',
        'post' : (gameObj.shortDetail ? gameObj.shortDetail : '')
      }
      gameObj.gameTime = gameTimeMap[gameObj.status] || ''

      let getGameStateClass = common.getGameStateClass(gameObj.status)

      const gameDetailsClassname = classNames('game-details', 'footer', sport, getGameStateClass)
      let gameStripClassname = classNames('game-strip', sport, getGameStateClass, game.broadcast)
      if(gameObj.status === 'post') {
        gameStripClassname = classNames(gameStripClassname, gameObj.teamWinnerClassName)
      }

      gameObj.scrollToLiveClass = (gameObj.status === 'in') ? 'liveGame' : ''

      gameObj.gameStripClassname = gameStripClassname
      gameObj.gameDetailsClassname = gameDetailsClassname

      if((gameObj.status === 'post') && (results.length < limit)) {
        results.push(gameObj)
      }
      if((gameObj.status === 'pre') && (fixtures.length < limit)) {
        fixtures.push(gameObj)
      }
      if((gameObj.status === 'in') && (live.length < limit)) {
        live.push(gameObj)
      }
    }
    //reverse only fixtures to display in chronological order
    fixtures = fixtures.reverse()
    schedule = { fixtures, results, live, heading, notes }

    return schedule
  },
  updateGameDateFormat: function (gameObj, tzOptions) {
    const displayTimeFormatted = gameObj.date ? dateFormat.convertDateTime(gameObj.date, tzOptions) : ''
    gameObj.displayTimeFormatted = displayTimeFormatted ? displayTimeFormatted.toUpperCase() : ''
    gameObj.dateFormatted = gameObj.date ? dateFormat.dateFormat(gameObj.date, 'date8', tzOptions.timeZone) : ''
    return gameObj
  },
  /**
   * [updateGameDates update game date format]
   * @param  {array} arr       [array of games]
   * @param  {object} tzOptions [timezone options]
   * @return {object}           [returns games]
   */
  updateGameDates: function (arr, tzOptions) {
    const arrLen = (typeof arr.length !== 'undefined')  ? arr.length : 0
    for(let i = 0; i < arrLen; i++) {
      let gameObj = flex.updateGameDateFormat(arr[i], tzOptions)
      let gameTimeMap = {
        'pre' : (gameObj.displayTimeFormatted ? gameObj.displayTimeFormatted : ''),
        'in' : 'LIVE',
        'post' : (gameObj.shortDetail ? gameObj.shortDetail : '')
      }
      gameObj.gameTime = gameTimeMap[gameObj.status] || ''
      arr[i] = gameObj
    }
    return arr
  },
  /**
   * [updateLeftColumnTimezones update timezones for all the games in left column]
   * @param  {object} leftcolumn [left column from flex api]
   * @param  {object} tzOptions  [timezone options]
   * @param {Object} edition edition information
   * @return {object}            [return left column]
   */
  updateLeftColumnTimezones: function (leftcolumn, tzOptions, edition) {
    let newTzOptions = {
      timeZone: tzOptions.zone,
      timeZoneAbbr: tzOptions.zoneAbbr,
      timeFormat: 'hh:mm a'
    }
    let schedule = selectn('schedule',leftcolumn)
    if(schedule) {
      let transObj = {
        key : 'All times in',
        timezone : newTzOptions.timeZoneAbbr || ''
      }

      let headingTimeZone = newTzOptions.timeZoneAbbr ? translate(edition, transObj) : ''
      let heading = selectn('heading', schedule)

      if(heading) {
        let isheadingTimeZonePresent = selectn('heading.timeZone', schedule) ? true : false
        leftcolumn.schedule.heading.timeZone = isheadingTimeZonePresent ? headingTimeZone : ''
      }

      let fixturesItems = selectn('fixtures.items', schedule) || []
      let resultsItems = selectn('results.items', schedule) || []
      let mobileItems = selectn('mobile', schedule) || []

      leftcolumn.schedule.fixtures.items = flex.updateGameDates(fixturesItems, newTzOptions) || []
      leftcolumn.schedule.results.items = flex.updateGameDates(resultsItems, newTzOptions) || []
      leftcolumn.schedule.mobile = flex.updateGameDates(mobileItems, newTzOptions) || []
    }
    return leftcolumn

  },
  /**
   * [getClubhouseTeam get clubhouse team details]
   * @param  {Object} data   [team details from api]
   * @param  {Object} params [template params]
   * @return {object}        [team details]
   */
  getClubhouseTeam: function (data = {}, params={}) {
    const logo = data.logo ? data.logo : common.defaultUrls.teamLogo
    data.recordSummary = data.recordSummary ? data.recordSummary : ''
    data.seasonSummary = data.seasonSummary ? data.seasonSummary : ''
    data.logo = common.resizeCombinerLogo(logo,{ w:0, h:0 })
    data.logoLarge = common.resizeCombinerLogo(logo,{ w:100, h:100 })
    data.href = common.createHref({ sport: params.sport, slug: params.slug, team: params.team, pageType: params.pageType }) || ''
    return data
  },
  /**
   * [getSchedulesMobile Get schedules data for mobile carousel]
   * @param  {Object} data  [schedule data]
   * @param  {Number} limit [number of games to be displayed, default=5]
   * @return {[array]}      [array of objects]
   */
  getSchedulesMobile: function (data={}, limit = 5) {
    let { fixtures=[], results=[], live=[] } = data
    const isLiveGamesPresent = (live.length > 0) ? true : false
    let matchesArr = []

    //add two results to matches array by default
    for(let c=0; c<2; c++) {
      if(results[c]) {
        matchesArr.push(results[c])
      }
    }
    //add live game in the middle
    if(isLiveGamesPresent) {
      matchesArr.push(live[0])
    }
    //add rest of fixtures
    for(let e=0; e < fixtures.length; e++) {
      if(fixtures[e]) {
        matchesArr.push(fixtures[e])
      }
      if(matchesArr.length === limit)
        break
    }
    return matchesArr
  },
  /**
   * [getSchedules get Fixtures from the left column in the flex api]
   * @param  {[object]} leftcolumn [default left column data from flex api]
   * @param  {[object]} edition    [edition details]
   * @param  {[object]} params     [template params]
   * @param  {[object]} team       [clubhouse team details]
   * @return {[object]}            [schedules formatted with pre,post,live with tab details]
   */
  getSchedules: function (leftcolumn, edition, params, team) {

    let { sport, pageType } = params
    let data = flex.getModuleByType (leftcolumn.items, 'schedule') || {}
    let schedule = { fixtures:{}, results:{}, live:{}, heading:{}, notes:'', mobile:[] }

    if(typeof data.feed !== 'undefined') {

      let scheduleItems = flex.getSchedulesItems(data.feed, sport, edition, pageType, 20, team) || {}
      let scheduleItemsMobile = flex.getSchedulesMobile(scheduleItems, 5) || []

      //adding live games to top of fixtures tab
      let liveArr = scheduleItems.live || []
      let fixturesArr = liveArr.concat(scheduleItems.fixtures) || []

      schedule = {
        fixtures : {
          name: 'fixtures',
          text: translate(edition, 'Fixtures'),
          items: fixturesArr,
          link: common.createHref({ sport: params.sport, team: params.team, pageType: 'fixtures' }) || ''
        },
        results : {
          name: 'results',
          text: translate(edition, 'Results'),
          items: scheduleItems.results || [],
          link: common.createHref({ sport: params.sport, team: params.team, pageType: 'results' }) || ''
        },
        moduleTitle: (data.moduleTitle || ''),
        moduleType: data.moduleType || '',
        heading: scheduleItems.heading || {},
        mobile: scheduleItemsMobile,
        fixturesLinkText: translate(edition, 'All Fixtures'),
        resultsLinkText: translate(edition, 'All Results'),
        notes: scheduleItems.notes || ''
      }
    }

    return schedule

  },
  getStandings: function (rightcolumn) {
    let data = this.getModuleByType(rightcolumn.items, 'standings') || {}
    let standings = {}
    let feed = data && data.feed && data.feed[0] || []
    standings.moduleType = data.moduleType
    standings.moduleTitle = data.moduleTitle
    standings.sport = data.sport
    standings.league = data.league
    standings.feed = feed
    return standings
  },
  getLeaders: function (rightcolumn) {
    let data = this.getModuleByType(rightcolumn.items, 'teamleaders')
    let leaders = {}
    leaders.moduleType = data.moduleType || ''
    leaders.moduleTitle = data.moduleTitle || ''
    leaders.season =  data.seasonSummary || ''
    leaders.feed = data.feed || []
    leaders.league = data.league || {}
    return leaders
  },
  /**
   * [getTypesByPageSport, This needs ot be updated as we add more page or to include addiotional type of content]
   * @param  {string} pageType  [page type - 'clubhouse or team', 'series', 'frontpage']
   * @param  {string} sport   [sport]
   * @return {typeForPageSport} [returns  types of items to keep in the actual feed for a page]
   */
  getTypesByPageSport: function (pageType, sport) {
    let typeForPageSport = []
    let acceptedType = {
      'team': [ //page type
        {
          'rugby' : [ 'Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External' ], // sport : [types that are accespted]
          'cricket': [ 'Blog', 'Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External' ],
          'soccer': [ 'Blog', 'Story', 'Recap', 'Preview', 'HeadlineNews', 'Media', 'External' ]
        }
      ],
      'default': [ 'Story', 'Blog', 'Recap', 'Previews', 'HeadlineNews', 'Media' ]
    }

    typeForPageSport = acceptedType['default']

    if (acceptedType.hasOwnProperty(pageType)) {
      let getPageType = acceptedType[pageType]
      if(getPageType[0].hasOwnProperty(sport)) {
        typeForPageSport = getPageType[0][sport]
      }
    }

    return typeForPageSport
  },
  getNewsItems: function (feed, limit, sport, domain, pageType) {
    let newsItems = []
    let typesAccepted = this.getTypesByPageSport (pageType, sport)
    Object.values(feed).forEach(function (v,i) {
      let item = feed[i] || {}
      if (typesAccepted.indexOf(item.type) > -1) { //get the type of content required for the page sport
        var webLinks = selectn('links.web', item) || {}
        var href = common.buildURL(webLinks.href || selectn('headline.href', webLinks), domain) || '#'

        //makikng urls to be relative
        if(sport === 'rugby' && item.type === 'Recap') {
          href = common.buildURL(webLinks.href || selectn('headline.href', webLinks)) || '#' //for recap keep as is from API,
        }else{
          href = common.buildURL(href || selectn('headline.href', webLinks)) || '#' //for others have formated urls
        }

        var isLinkExternal = common.isLinkExternal(href, domain)
        var imgCombinerUrl = common.getCombinerImage(selectn('images[0][url]', item)) || '#'
        var imgAvailable = (imgCombinerUrl === '#') ? false : true
        newsItems.push({
          id: item.id,
          type: item.type,
          headline: item.headline,
          linktext: item.linkText,
          description: item.description,
          href: href,
          isLinkExternal: isLinkExternal,
          target: isLinkExternal ? '_blank' : '',
          aLinkClass : isLinkExternal ? 'external realStory' : 'realStory',
          image: selectn('images[0]', item) || {},
          imgCombinerUrl: imgCombinerUrl,
          imgAvailable: imgAvailable,
          video: selectn('video[0]', item) || {},
          published: relativeDate(new Date(item.published)) ,
          byline: item.byline,
          related: item.related,
          imgUrl : selectn('images[0][url]', item) || '#'
        })
      }
    })

    newsItems = newsItems.slice(0, limit)
    return newsItems
  },
  getNewsFeed: function (middlecolumn, sport, domain, pageType, currentArticleCount, loadNowAPI) {
    let data = loadNowAPI ? middlecolumn : this.getModuleByType(middlecolumn.items)
    let feed = data && data.feed || []
    let newsfeed = {}
    let resultsCount = data.resultsCount
    let resultsOffset = data.resultsOffset

    newsfeed = this.getNewsItems(feed, 25, sport, domain, pageType, currentArticleCount) //actual feed
    newsfeed.resultsCount = resultsCount  //total results
    newsfeed.resultsOffset = resultsOffset //offset count
    newsfeed.countBF = feed.length

    return newsfeed
  }
}

export default {
  buildEditorialItems: flex.buildEditorialItems,
  buildNewsItems: flex.buildNewsItems,
  getModuleByType: flex.getModuleByType,
  getColumnByName: flex.getColumnByName,
  getSchedules: flex.getSchedules,
  getClubhouseTeam: flex.getClubhouseTeam,
  getSchedulesItems: flex.getSchedulesItems,
  getSchedulesMobile: flex.getSchedulesMobile,
  getStandings: flex.getStandings,
  getLeaders: flex.getLeaders,
  getTypesByPageSport: flex.getTypesByPageSport,
  getNewsItems: flex.getNewsItems,
  getNewsFeed: flex.getNewsFeed,
  updateLeftColumnTimezones: flex.updateLeftColumnTimezones,
  updateGameDateFormat: flex.updateGameDateFormat
}



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/flex.js